import { de_DE as de } from '@fancyapps/ui/dist/fancybox/l10n/de_DE';
import { fr_FR as fr } from '@fancyapps/ui/dist/fancybox/l10n/fr_FR';
import { es_ES as es } from '@fancyapps/ui/dist/fancybox/l10n/es_ES';
import { de_DE as carouselDE } from '@fancyapps/ui/dist/carousel/l10n/de_DE';
import { fr_FR as carouselFR } from '@fancyapps/ui/dist/carousel/l10n/fr_FR';
import { es_ES as carouselES } from '@fancyapps/ui/dist/carousel/l10n/es_ES';

export const l10n = {
  de: {
    ...de,
    ...carouselDE
  },
  fr: {
    ...fr,
    ...carouselFR
  },
  es: {
    ...es,
    ...carouselES
  },
  ru: {
    ERROR: 'Запрошенный документ не может быть загружен. <br/> Пожалуйста, попробуйте позже.',
    NEXT: 'Вперед',
    PREV: 'Назад',
    MODAL: 'Вы можете выйти, нажав клавишу ESC',
    ELEMENT_NOT_FOUND: 'Элемент HTML не найден',
    IFRAME_ERROR: 'Ошибка загрузки страницы',
    GOTO: 'Перейти к слайду №%d',
    DOWNLOAD: 'Скачать',
    TOGGLE_FULLSCREEN: 'Полный экран',
    TOGGLE_EXPAND: 'Полный размер',
    TOGGLE_THUMBS: 'Миниатюры',
    TOGGLE_AUTOPLAY: 'Показ слайдов',
    IMAGE_ERROR: 'Изображение не найдено',
    MOVE_UP: 'Сдвинуть вверх',
    MOVE_DOWN: 'Сдвинуть вниз',
    MOVE_LEFT: 'Сдвинуть влево',
    MOVE_RIGHT: 'Сдвинуть вправо',
    ZOOM_IN: 'Увеличить',
    ZOOM_OUT: 'Уменьшить',
    TOGGLE_FULL: 'Переключить 1:1',
    TOGGLE_1TO1: 'Переключить 1:1',
    ITERATE_ZOOM: 'Переключить увеличение',
    ROTATE_CCW: 'Повернуть против часовой стрелки',
    ROTATE_CW: 'Повернуть по часовой стрелке',
    FLIP_X: 'Перевернуть горизонтально',
    FLIP_Y: 'Перевернуть вертикально',
    RESET: 'Сброс',
    CLOSE: 'Закрыть'
  }
};
